<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        Missing pets list
      </h1>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 text-center py-5">

      <div class="row">
        <div class="col-12 col-sm-6 mb-2">
          [FILTERS]
        </div>
        <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end align-items-center mb-2">
          <app-postcode-field
            class="d-inline-block me-3"
            [(loading)]="loading"
            [(postcode)]="postcode">
          </app-postcode-field>
          <button
            class="btn btn-inline-block btn-primary text-white"
            (click)="search()"
            [disabled]="postcode.status != 1 || loading"
            type="button">
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'" class="me-3">
            </fa-icon>
            Search
          </button>
        </div>
      </div>

    </div>
  </div>

  <div class="row">
    <div class="col-12">

      <h4
        *ngIf="searchFilters.location && searchFilters.location.name"
        class="d-block text-center mb-5">
        Search results for {{ searchFilters.location.name | uppercase }}: [NUM] results
      </h4>

      <div
        *ngIf="!loading"
        class="row">
        <div
          *ngFor="let missingPet of missingPets"
          class="col-12 col-sm-6 col-md-4 col-lg-3 mb-5">

          <div
            class="card"
            [ngClass]="{'alert-success': missingPet.status === 'found',
                        'alert-danger': missingPet.status === 'stolen',
                        'alert-secondary': missingPet.status === 'missing'}">

            <div
              class="card-img-top"
              [ngStyle]="missingPet.pet.imageUrl && {'background-image': 'url(' + missingPet.pet.imageUrl + ')'}">
            </div>

            <div class="card-body pb-0">
              <h6 class="card-title my-0">
                <span
                  ngbTooltip="Pet name"
                  placement="top">
                  {{ missingPet.pet.name }}
                </span>
              </h6>
            </div>

            <div class="card-body pb-0">

              <p class="mb-1">
                <span
                  ngbTooltip="Date reported missing"
                  placement="top">
                  <fa-icon
                    class="me-2"
                    [icon]="['fas', 'calendar-alt']">
                  </fa-icon>
                  <span class="fw-bold">
                    {{ missingPet.reported.date | date: 'dd/MM/yyyy' }}
                  </span>
                </span>
              </p>

              <p class="mb-1">
                <span
                  ngbTooltip="Reference number"
                  placement="top">
                  <fa-icon
                    class="me-2"
                    [icon]="['fas', 'hashtag']">
                  </fa-icon>
                  <span class="fw-bold">
                    {{ missingPet.reference | uppercase }}
                  </span>
                </span>
              </p>

              <p class="mb-1">
                <span
                  ngbTooltip="Current status"
                  placement="top">
                  <fa-icon
                    class="me-2"
                    [icon]="['fas', 'exclamation-circle']">
                  </fa-icon>
                  <span
                    class="badge"
                    [ngClass]="{'bg-success': missingPet.status === 'found',
                                'bg-danger': missingPet.status === 'stolen',
                                'bg-warning': missingPet.status === 'missing'}">
                    {{ missingPet.status | titlecase }}
                  </span>
                </span>
              </p>

            </div>

            <div class="card-body">
              <a  class="btn w-100"
                  [ngClass]="{'btn-success text-white': missingPet.status === 'found',
                              'btn-primary': missingPet.status != 'found'}"
                  [routerLink]="['/lost-and-found/missing-pet', missingPet.reference]">
                View
              </a>
            </div>
          </div>


        </div>
      </div>

    </div>
  </div>

</div>
